document.addEventListener('DOMContentLoaded', function () {
    var active = false;
    document.querySelectorAll('.block-items-with-collapse__item__read-more').forEach(function (i) {
        i.addEventListener('click', function (e) {
            const item = $("div").find("[data-collapse-desc='" + i.dataset.collapseItem + "']")[0];
            if (item.classList.contains('active')) {
                active = i;
                i.classList.remove('active')
                item.classList.remove('active');
            } else {
                active = false;
                document.querySelectorAll('.block-items-with-collapse__desc').forEach(function (x) {
                    return x.classList.remove('active')
                });
                document.querySelectorAll('.block-items-with-collapse__item__read-more').forEach(function (x) {
                    return x.classList.remove('active')
                });
                item.classList.add('active');
                i.classList.add('active');
                // scrollCollapse(item);
            }
        });
    });
    // const scrollCollapse = function (elem) {
    //     let offset = jQuery(elem).offset().top;
    //     console.log(offset);
    //     jQuery('html, body').animate({scrollTop: (offset - ($(window).height()/2))}, 300);
    // };
    document.addEventListener( 'click', function( e ) {
        if (!e.target.classList.contains('block-items-with-collapse__item__read-more')) {
            active = false;
            document.querySelectorAll('.block-items-with-collapse__desc').forEach(function (x) {
                return x.classList.remove('active')
            });
            document.querySelectorAll('.block-items-with-collapse__item__read-more').forEach(function (x) {
                return x.classList.remove('active')
            });
        }
        else{
        }
    })
});
